/******PageFooter******/
/*PAGE*/
export default function PageFooter() {
  /*DOM*/
  return (
    <div className="pageFooter">
      <img
        fetchpriority="high"
        src="/img/Logo2.webp"
        className="logo2 bigLogo bigLogo2"
        alt="Logo des financeurs UNANIMES"
      />

      <div className="mapWrap">
        <p>Nîmes Université</p>
        <p>Rue du Docteur Georges Salan CS 13019 30021 Nîmes</p>

        <iframe
          src="https://maps.google.com/maps?q=/Université+Vauban 30000&z=6&output=embed"
          style={{ border: 0 }}
          loading="lazy"
        />
      </div>
    </div>
  );
/*format modif--*/
}
